import http from '@/http'
import formatDate from '@/utils/formatDate'

export default {
  namespaced: true,
  actions: {
    async createOrder(context, order) {
      const response = await http.post(`order/electricity`, {
        assignId: order.assignId,
        customerId: order.customerId,
        productId: order.electricityOrder.supplierProductId,
        calculator: {
          distributorId: order.electricityOrder.distributorId,
          rateId: order.electricityOrder.rateId,
          circuitBreakerId: order.electricityOrder.circuitBreakerId,
          productId: order.electricityOrder.currentSupplierProductId,
          areaId: order.electricityOrder.areaId,
          personId: order.electricityOrder.personId,
          usageIds: order.electricityOrder.usageIds,
          postalCode: order.electricityOrder.postalCode,
          consumptionHT: order.electricityOrder.consumptionHT,
          consumptionLT: order.electricityOrder.consumptionLT
            ? order.electricityOrder.consumptionLT
            : 0,
        },
        ean: order.electricityOrder.ean,
        advanceAmount: order.electricityOrder.advanceAmount,
        advancePeriod: order.electricityOrder.advancePeriod,
        advanceType: order.electricityOrder.advanceType,
        bankAccountNumber: order.electricityOrder.bankAccountNumber,
        bankCode: order.electricityOrder.bankCode,
        sipoNumber: order.electricityOrder.sipoNumber,
        customerType: order.electricityOrder.customerType,
        connectionBegin: formatDate(order.electricityOrder.connectionBegin),
        contractEnd: formatDate(order.electricityOrder.contractEnd),
        terminationPeriod: order.electricityOrder.terminationPeriod,
        terminationPeriodType: order.electricityOrder.terminationPeriodType,
        renewalPeriod: order.electricityOrder.renewalPeriod,
        renewalPeriodUnit: order.electricityOrder.renewalPeriodUnit,
        renewalPeriodType: order.electricityOrder.renewalPeriodType,
        contractSigned: order.electricityOrder.contractSigned,
        contractType: order.electricityOrder.contractType,
        contractBonus: order.electricityOrder.contractBonus,
        contractConcludingType: order.electricityOrder.contractConcludingType,
        contractTerminationType: order.electricityOrder.contractTerminationType,
        supplierChangeType: order.electricityOrder.supplierChangeType,
        invoicePdf: order.electricityOrder.invoicePdf,
        invoicePdfEmail: order.electricityOrder.invoicePdfEmail,
        refund: order.electricityOrder.refund,
        gdpr: order.electricityOrder.gdpr,
        marketing: order.electricityOrder.marketing,
        dataSentenceProduct: order.electricityOrder.dataSentenceProduct,
        dataSentenceSupplierId: order.electricityOrder.dataSentenceSupplierId,
        serviceProvideImmediately: order.electricityOrder.serviceProvideImmediately,
        affidavitCustomerDied: order.electricityOrder.affidavitCustomerDied,
        affidavitCustomerLeft: order.electricityOrder.affidavitCustomerLeft,
        affidavitCustomerDate: formatDate(order.electricityOrder.affidavitCustomerDate),
      })

      return response
    },
    async updateOrder(context, order) {
      const response = await http.put(`order/electricity/${order.electricityOrder.id}`, {
        productId: order.electricityOrder.supplierProductId,
        calculator: {
          distributorId: order.electricityOrder.distributorId,
          rateId: order.electricityOrder.rateId,
          circuitBreakerId: order.electricityOrder.circuitBreakerId,
          productId: order.electricityOrder.currentSupplierProductId,
          areaId: order.electricityOrder.areaId,
          personId: order.electricityOrder.personId,
          usageIds: order.electricityOrder.usageIds,
          postalCode: order.electricityOrder.postalCode,
          consumptionHT: order.electricityOrder.consumptionHT,
          consumptionLT: order.electricityOrder.consumptionLT
            ? order.electricityOrder.consumptionLT
            : 0,
        },
        ean: order.electricityOrder.ean,
        advanceAmount: order.electricityOrder.advanceAmount,
        advancePeriod: order.electricityOrder.advancePeriodName,
        advanceType: order.electricityOrder.advanceTypeName,
        bankAccountNumber: order.electricityOrder.bankAccountNumber,
        bankCode: order.electricityOrder.bankCode,
        sipoNumber: order.electricityOrder.sipoNumber,
        customerType: order.electricityOrder.customerTypeName,
        connectionBegin: formatDate(order.electricityOrder.connectionBegin),
        contractEnd: formatDate(order.electricityOrder.contractEnd),
        terminationPeriod: order.electricityOrder.terminationPeriod,
        terminationPeriodType: order.electricityOrder.terminationPeriodTypeName,
        renewalPeriod: order.electricityOrder.renewalPeriod,
        renewalPeriodUnit: order.electricityOrder.renewalPeriodUnitName,
        renewalPeriodType: order.electricityOrder.renewalPeriodTypeName,
        contractSigned: order.electricityOrder.contractSigned,
        contractType: order.electricityOrder.contractTypeName,
        contractBonus: order.electricityOrder.contractBonus,
        contractConcludingType: order.electricityOrder.contractConcludingTypeName,
        contractTerminationType: order.electricityOrder.contractTerminationTypeName,
        supplierChangeType: order.electricityOrder.supplierChangeTypeName,
        invoicePdf: order.electricityOrder.invoicePdf,
        invoicePdfEmail: order.electricityOrder.invoicePdfEmail,
        refund: order.electricityOrder.refund,
        gdpr: order.electricityOrder.gdpr,
        marketing: order.electricityOrder.marketing,
        dataSentenceProduct: order.electricityOrder.dataSentenceProduct,
        dataSentenceSupplierId: order.electricityOrder.dataSentenceSupplierId,
        serviceProvideCity: order.electricityOrder.serviceProvideCity,
        serviceProvideImmediately: order.electricityOrder.serviceProvideImmediately,
        affidavitCustomerDied: order.electricityOrder.affidavitCustomerDied,
        affidavitCustomerLeft: order.electricityOrder.affidavitCustomerLeft,
        affidavitCustomerDate: formatDate(order.electricityOrder.affidavitCustomerDate),
      })

      return response
    },
    async createWorkOrder(context, order) {
      const response = await http.post(`order/electricity/work`, {
        assignId: order.assignId,
        customerId: order.customerId,
        distributorId: order.electricityWorkOrder.distributorId,
        postalCode: order.electricityWorkOrder.postalCode,
        areaId: order.electricityWorkOrder.areaId,
        typeIds: order.electricityWorkOrder.typeIds,
        term: formatDate(order.electricityWorkOrder.term),
        content: order.electricityWorkOrder.content,
        ean: order.electricityWorkOrder.ean,
      })

      return response
    },
    async updateWorkOrder(context, order) {
      const response = await http.put(`order/electricity/work/${order.electricityWorkOrder.id}`, {
        distributorId: order.electricityWorkOrder.distributorId,
        postalCode: order.electricityWorkOrder.postalCode,
        areaId: order.electricityWorkOrder.areaId,
        typeIds: order.electricityWorkOrder.typeIds,
        term: formatDate(order.electricityWorkOrder.term),
        content: order.electricityWorkOrder.content,
        ean: order.electricityWorkOrder.ean,
      })

      return response
    },
    async getElectricityWorkOrderTypes(context, { type }) {
      const response = await http.get(`order/electricity/work/type?type=${type}`)

      return response
    },
    async getElectricityWorkOrderAreas() {
      const response = await http.get(`order/electricity/work/area`)

      return response
    },
    async calculate(context, form) {
      const response = await http.post(`calculator/electricity/calculate`, {
        postalCode: form.postalCode,
        consumptionHT: form.consumptionHT,
        consumptionLT: form.consumptionLT,
        distributorId: form.distributorId,
        rateId: form.rateId,
        circuitBreakerId: form.circuitBreakerId,
        supplierId: form.supplierId,
        supplierProductId: form.supplierProductId,
      })
      return response
    },
    async calculateState(context, input) {
      const response = await http.post(`calculator/electricity/state`, {
        areaId: input.areaId,
        personId: input.personId,
        usageIds: input.usageIds,
      })
      return response
    },
    async getCircuitBreaker(context, { distributorId, rateId }) {
      const response = await http.get(
        `electricity/circuit-breaker?distributorId=${distributorId}&rateId=${rateId}`
      )

      return response
    },
    async getRates() {
      const response = await http.get(`electricity/rate`)

      return response
    },
    async searchDistributor() {
      const response = await http.get(`distributor/search?type=ELECTRICITY`)

      return response
    },
    async getDistributor(context, postalCode) {
      const response = await http.get(`distributor?postalCode=${postalCode}&type=ELECTRICITY`)

      return response
    },
    async getDistributorByType(context, { postalCode, type }) {
      const response = await http.get(`distributor?postalCode=${postalCode}&type=${type}`)

      return response
    },
    async getSuppliers() {
      const response = await http.get(`supplier?type=ELECTRICITY`)

      return response
    },
    async getSupplierProducts(context, { id, distributorId, distributionRateId }) {
      const response = await http.get(
        `supplier/${id}/product?type=ELECTRICITY&distributorId=${distributorId}&distributionRateId=${distributionRateId}`
      )

      return response
    },
  },
}
